import { FieldComponentProps } from "components/forms/FormKit";

import { TeamMember } from "graphql/generated/types";
import { useFieldArray } from "react-hook-form";
import { recursiveCamelToSnakeJS, recursiveSnakeToCamel } from "utils/utils";
import { TeamMembers } from "./TeamMembers";

type TeamMembersProps = Pick<
    FieldComponentProps,
    "control" | "field" | "getValues"
>;

export interface EntryDialogTeamMember extends TeamMember {
    athleteId?: string;
    _destroy?: boolean;
    teamRoleId?: string;
    teamRoleName?: string;
}

export const EntryDialogTeamMembers: React.FC<TeamMembersProps> = ({
    control,
    field,
    getValues,
}) => {
    const { append, update, remove } = useFieldArray({
        name: field.name,
        control,
    });
    const members = recursiveCamelToSnakeJS(getValues(field.name), [
        "_destroy",
    ]);
    const array = {
        push: (_: never, value: any) =>
            append(recursiveSnakeToCamel(value, ["_destroy"])),
        splice: (_: never, start: number, _end: never, value: any) =>
            value === null
                ? remove(start)
                : update(start, recursiveSnakeToCamel(value, ["_destroy"])),
    };
    return (
        <TeamMembers
            array={array}
            members={members}
            teamRoles={field.teamRoles}
        />
    );
};
